module.exports = __webpack_public_path__ + "static/img/zhongzhongka4.eeaa732.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka4.png
// module id = b9Wk
// module chunks = 16